<div
    [class.ontp-linked]="_matchesFocus && _isLinked"
    [class.ontp-linked-has-tag]="
        _matchesFocus && _isLinked && _value.behaviourId != null
    "
    [formGroup]="_form.form"
>
    <div
        class="ontp-tag-group-header-container"
        [class.ontp-tag-group-has-tag]="_value.behaviourId != null"
    >
        <div
            [class.uncoached-container-for-focus-header]="
                _value.behaviourId == null
            "
            [class.container-for-focus-header]="_value.behaviourId != null"
            [class.ontp-behaviour-draft]="
                !published &&
                _value.behaviourId != null &&
                !_hasActiveCommitment
            "
            [class.ontp-sub-behaviour-draft]="
                !published &&
                _value.behaviourId != null &&
                !_hasActiveCommitment
            "
            [id]="_value.behaviourId == null && _value.trackingId"
        >
            <div
                class="ontp-tag-group-header"
                role="heading"
                aria-level="2"
            >
                <ng-container
                    *ngIf="
                        _focusInfo?.behaviourName ||
                            _focusInfo?.subBehaviourName;
                        else onlyFullName
                    "
                >
                    <div
                        [class.uncoachedbehaviour]="_value.behaviourId == null"
                        [class.behaviour]="_value.behaviourId != null"
                        *ngIf="
                            !displayProperties ||
                            !displayProperties.hideBehaviour
                        "
                    >
                        <span
                            class="cmps-cdk-flex-100 cmps-cdk-py-0dot75"
                            *ngIf="_value.behaviourId == null; else elseBlock"
                        >
                            {{
                                _i18n._9579_FOCUS_CONTAINER__UNFOCUSED_
                                    | translate
                            }}
                        </span>
                        <ng-template #elseBlock>
                            <span class="cmps-cdk-flex-100 cmps-cdk-py-0dot5">
                                {{ _i18n._7334_BEHAVIOUR | translate }}:
                                {{ _focusInfo?.behaviourName }}
                            </span>
                        </ng-template>
                        <div
                            class="d-flex align-items-center"
                            *ngIf="
                                (!displayProperties ||
                                    !displayProperties.hideContextMenu) &&
                                _menuOpts?.length
                            "
                        >
                            <button
                                class="cmps-icon-button--no-bg cmps-icon-button--no-bg--white"
                                cmpsIconButton
                                [cmpsMenuTrigger]="menu"
                                placement="bottom-right"
                            >
                                <cmps-icon
                                    svgIcon="dots-horizontal"
                                ></cmps-icon>
                            </button>
                            <cmps-menu #menu="cmpsMenu">
                                <ng-container *ngFor="let item of _menuOpts">
                                    <button
                                        class="cmps-button--no-bg cmps-button--left"
                                        cmpsButton
                                        (click)="_onMenuItemClick(item)"
                                    >
                                        <cmps-icon
                                            [svgIcon]="item.icon"
                                        ></cmps-icon>
                                        <span cmpsButtonLabel>{{
                                            item.label
                                        }}</span>
                                    </button>
                                </ng-container>
                            </cmps-menu>
                        </div>
                    </div>
                    <div
                        [class.uncoachedsubbehaviour]="
                            _value.behaviourId == null
                        "
                        [class.subbehaviour]="_value.behaviourId != null"
                        *ngIf="
                            !displayProperties ||
                            !displayProperties.hideSubbehaviour
                        "
                    >
                        <span class="cmps-cdk-flex-100 cmps-cdk-py-0dot5">
                            {{ _i18n._7336_SUB_BEHAVIOUR | translate }}:
                            {{ _focusInfo?.subBehaviourName }}
                        </span>
                        <cmps-coaching-bl-button
                            [focus]="_selected"
                        ></cmps-coaching-bl-button>
                    </div>
                </ng-container>
                <ng-template #onlyFullName>
                    <div>{{ _focusInfo?.name }}</div>
                </ng-template>
            </div>
        </div>
    </div>

    <cmps-observation-focus-summary
        [class.d-none]="isCollapsed"
        [class.preview-container]="isCollapsed"
        [storePathPrefix]="storePathPrefix"
        [observationId]="observationId"
        [published]="published"
        [performerId]="performerId"
        [interactionEntity]="interactionEntity"
        [focus]="_value"
        [interactions]="_value.interactions"
        [hideSubSummary]="
            displayProperties && displayProperties.hideEvaluations
        "
    ></cmps-observation-focus-summary>

    <div
        class="px-3"
        [class.d-none]="isCollapsed"
    >
        <div
            cmpsObservationInteractions
            [storePathPrefix]="storePathPrefix"
            [config]="interactionEntity"
            [published]="published"
            [defaultInteractionTypeId]="defaultInteractionTypeId"
            [defaultNoteCategory]="defaultNoteCategory"
            [focus]="_value"
            [formControlName]="_TagGroupFormFields.INTERACTIONS.name"
            *ngIf="allowedActions?.displayInteractions"
        ></div>
    </div>
    <div
        class="d-flex align-items-center justify-content-center mb-3"
        *ngIf="
            (!_readonly || _readonly.value === false) &&
            allowedActions?.addInteraction
        "
    >
        <button
            [class.d-none]="isCollapsed"
            cmpsIconButton
            [attr.aria-label]="
                _i18n._9623_OBSERVE_A_NEW_INTERACTION | translate
            "
            (click)="_onAddInteractionClick()"
        >
            <cmps-icon svgIcon="headset"></cmps-icon>
            <span cmpsIconButtonLabel>{{
                _i18n._9623_OBSERVE_A_NEW_INTERACTION | translate
            }}</span>
        </button>
    </div>
    <div
        class="px-3"
        [class.no-height-invisible]="isCollapsed"
    >
        <cmps-tag-set-trigger
            [storePathPrefix]="storePathPrefix"
            [mode]="_TagSetMode.METRIC_ONLY"
            [performerId]="performerId"
            [selected]="_selected"
            [pinnedMetrics]="_pinnedMetrics"
            (save)="_onAddMetricClick($event)"
            #trigger
        ></cmps-tag-set-trigger>
        <div
            cmpsObservationKpiSet
            [storePathPrefix]="storePathPrefix"
            [focus]="_value"
            [performerId]="performerId"
            [readonly]="_form.form.disabled"
            [metrics]="metrics"
            (removeMetricClick)="_onRemoveMetricClick($event)"
            (addMetricClick)="trigger.open()"
            *ngIf="!_form.form.disabled || _value?.metrics?.length > 0"
        ></div>
    </div>
    <div
        class="d-flex align-items-center justify-content-center kpi-select-container"
    >
        <span [class.d-none]="true"
            >{{ _i18n._9619_SELECTED_KPIS_ | translate }}&nbsp;</span
        >
        <span
            [class.d-none]="true"
            class="kpi-selected"
            >{{ _kpiSelectedStr || '-' }}</span
        >
    </div>
    <div
        class="d-flex align-items-center justify-content-center collapse-button"
        *ngIf="!displayProperties || !displayProperties.diableExpandFocus"
    >
        <button
            class="cmps-icon-button--no-bg"
            cmpsIconButton
            [id]="_value.behaviourId"
            (click)="_onToggleCollapseClick()"
        >
            <cmps-icon
                [svgIcon]="isCollapsed ? 'chevron-down' : 'chevron-up'"
            ></cmps-icon>
        </button>
    </div>
</div>
